var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "theme-fill",
    d: "M12.6562 0H0.84375C0.377754 0 0 0.377754 0 0.84375V1.40625C0 1.87225 0.377754 2.25 0.84375 2.25C0.84375 5.44799 2.63728 8.1469 5.0921 9C2.63728 9.8531 0.84375 12.552 0.84375 15.75C0.377754 15.75 0 16.1278 0 16.5938V17.1562C0 17.6222 0.377754 18 0.84375 18H12.6562C13.1222 18 13.5 17.6222 13.5 17.1562V16.5938C13.5 16.1278 13.1222 15.75 12.6562 15.75C12.6562 12.552 10.8627 9.8531 8.4079 9C10.8627 8.1469 12.6562 5.44799 12.6562 2.25C13.1222 2.25 13.5 1.87225 13.5 1.40625V0.84375C13.5 0.377754 13.1222 0 12.6562 0ZM10.4062 15.75H3.09375C3.09375 13.0269 4.71811 10.6875 6.75 10.6875C8.78154 10.6875 10.4062 13.026 10.4062 15.75Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.e1c8aba6.svg";
export { ForwardRef as ReactComponent };